const n = "_container_17dy2_1", t = {
  container: n
};
export {
  n as container,
  t as default
};
//# sourceMappingURL=index.es5841.js.map
